<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";
import router from "@/router";

const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = async (type, data) => {
  await uiStore.setModalAction(type);
  uiStore.setModalState(true);
  await uiStore.setModalData(data);

  if (type == 'show_data_mapping') {
    router.push(`/data-mappings/${data.session_id}/files`);
  }
};
</script>

<template>
  <div class="actions-cell">
    <button @click="action('generate_file_data_mapping', props.data)" type="button" class="icon-button" title="Generate Mapped File">
      <LIcon name="zap" />
    </button>
    <button @click="action('delete_file_data_mapping', props.data)" type="button" class="icon-button danger" title="Delete">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
